// Filters the product gallery -- BOTH the slides AND the dot indicators
// -- to show only images matching the selected color swatch, and jumps
// directly to the first matching image. Genuinely reduces the visible dot
// count to match the number of images for that color.
//
// SCOPED: only runs on the specific landing pages that needed this
// fix. On every other product page, this script does nothing at all.
const SCOPED_HANDLES = [
  'body-vita-stretta-peso-lp',
  'body-vita-stretta-cerimonia-lp',
  'body-vita-stretta-cquestion-lp',
  'tuta-scolpente-zip-frontale',
  'hip-lifting-fitness-leggings-tummy-control-workout-running-gym-yoga-pants-for-women',
  'body-modellante-donna',
  'body-scolpente-controllo-pancia-push-up',
];
const isScopedPage = SCOPED_HANDLES.some((handle) => window.location.pathname.includes(handle));

if (isScopedPage) {
  // IMPORTANT: Shopify's native <media-gallery> (assets/media-gallery.js)
  // listens for the 'variant:update' event and, once the background section
  // fetch resolves, completely REPLACES the entire gallery element with a
  // fresh server-rendered (unfiltered) one. This happens shortly AFTER a
  // swatch click -- undoing whatever filtering we just did. To handle this,
  // we also listen for that same 'variant:update' event on document; since
  // it bubbles and media-gallery's own listener sits on a closer ancestor,
  // our document-level listener fires AFTER the native replacement, letting
  // us re-apply the filter to the freshly-swapped-in gallery element.
  //
  // Deliberately does NOT touch <variant-picker> or simulate clicks on any
  // swatch input -- it only listens to native events already dispatched by
  // the theme, running independently alongside them.

  const getGalleryColors = () =>
    new Set(
      Array.from(document.querySelectorAll('slideshow-slide img'))
        .map((img) => (img.alt || '').trim().toLowerCase())
        .filter(Boolean)
    );

  const filterGalleryByColor = (color) => {
    const slideshow = document.querySelector('slideshow-component');
    if (!slideshow) return;

    const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
    const dotItems = Array.from(slideshow.querySelectorAll('.slideshow-controls__dots > li'));

    let firstMatchId = null;

    slides.forEach((slide, index) => {
      const img = slide.querySelector('img');
      const slideColor = (img?.alt || '').trim().toLowerCase();
      const matches = slideColor === color;
      const slideId = slide.getAttribute('slide-id');

      if (matches) {
        slide.removeAttribute('hidden');
        if (!firstMatchId) firstMatchId = slideId;
      } else {
        slide.setAttribute('hidden', '');
      }

      const dotLi = dotItems[index];
      if (dotLi) {
        dotLi.style.display = matches ? '' : 'none';

        const dotButton = dotLi.querySelector('button');
        if (dotButton && slideId) {
          dotButton.onclick = (event) => {
            event.preventDefault();
            if (typeof slideshow.select === 'function') {
              slideshow.select({ id: slideId }, event);
            }
          };
        }
      }
    });

    if (firstMatchId && typeof slideshow.select === 'function') {
      slideshow.select({ id: firstMatchId }, undefined, { animate: false });
    }
  };

  const getCheckedColor = (galleryColors) => {
    const radios = document.querySelectorAll('variant-picker fieldset input[type="radio"]');
    for (const input of radios) {
      if (!input.checked) continue;
      const value = (input.value || '').trim().toLowerCase();
      if (galleryColors.has(value)) return value;
    }
    return null;
  };

  const applyCurrentFilter = () => {
    const galleryColors = getGalleryColors();
    if (!galleryColors.size) return;
    const currentColor = getCheckedColor(galleryColors);
    if (currentColor) filterGalleryByColor(currentColor);
  };

  // Immediate filtering on swatch click, for a fast, flash-free response.
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.type !== 'radio') return;
    if (!target.closest('variant-picker')) return;

    const galleryColors = getGalleryColors();
    const value = (target.value || '').trim().toLowerCase();
    if (!galleryColors.has(value)) return; // ignore Size radios, etc.

    filterGalleryByColor(value);
  });

  // Re-apply the filter after Shopify's native media-gallery replaces
  // itself in response to the same variant change (see comment above).
  document.addEventListener('variant:update', () => {
    requestAnimationFrame(applyCurrentFilter);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCurrentFilter);
  } else {
    applyCurrentFilter();
  }
}
